/* eslint-disable react/no-did-update-set-state */
import React, { Component } from "react";
import { connect } from "dva";
import TreeList from "../../../components/TreeList";
import { GetQueryString } from "../../../../../../utils/utils";
import GroupView from "./GroupView";
import RootView from "./RootView";
import DetailView from "./DetailView";
import styles from "./index.less";

@connect(({ projectCriterion, tree }) => ({
  ...projectCriterion,
  isRoot: tree.isRoot,
  spinProps: projectCriterion.spinProps
}))
class CriterionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectNormType: 0,
      showComponent: false,
      // showCriterionModal: false,
      indexCode: "",
      showTree: false
    };
  }

  componentDidMount() {
    this.currentProjectId = GetQueryString("currentProjectId");
    const { respondentOrgId } = this.props;
    this.respondentOrgId = respondentOrgId || "";
    this.getEvaluateTree();
  }

  // componentDidUpdate() {
  //   const { showComponent } = this.state;
  //   if(!showComponent) {
  //     this.setState({
  //       showComponent: true,
  //     })
  //   }
  // }

  // 获取指标树
  getEvaluateTree = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/getEvaluateTree",
      payload: {
        projectId: this.currentProjectId,
        respondentOrgId: this.respondentOrgId
      },
      callback: () => {
        this.setState({
          showComponent: true,
          showTree: true
        });
      }
    });
  };

  // 重新选择模板后的回调
  handleReselectTemplate = () => {
    // this.forceUpdate()
    this.setState(
      {
        showTree: false
      },
      () => {
        this.setState({
          showTree: true
        });
      }
    );
  };

  handleChangeSelect = ({ type, id }) => {
    this.setState(
      {
        selectNormType: type,
        indexCode: id,
        showComponent: false
      },
      () => {
        this.setState({
          showComponent: true
        });
      }
    );
  };

  renderRoot = () => {
    this.setState({
      selectNormType: 0
    });
  };

  renderContent = () => {
    const { selectNormType, indexCode } = this.state;
    if (selectNormType === 0) {
      return <RootView respondentOrgId={this.respondentOrgId || ""} handleReselectTemplate={this.handleReselectTemplate} />;
    }
    if (selectNormType === 2) {
      return (
        <DetailView
          record={{
            indexCode,
            projectId: this.currentProjectId,
            respondentOrgId: this.respondentOrgId
          }}
          renderRoot={this.renderRoot}
        />
      );
    }
    if (selectNormType === 1) {
      return (
        <GroupView
          record={{
            indexCode,
            projectId: this.currentProjectId,
            respondentOrgId: this.respondentOrgId
          }}
          renderRoot={this.renderRoot}
        />
      );
    }
    return null;
  };

  render() {
    const { showComponent, showTree } = this.state;

    return (
      <div className={styles.criterion}>
        <div className="container">
          <div className="norm-wrap">
            <div className="left-side">
              <div className="leftSideContainer">
                {showTree && (
                  <TreeList
                    onSelect={this.handleChangeSelect}
                    needRememberNowNode={0}
                    expandAllTree
                  />
                )}
              </div>
            </div>
            <div className="right-side">
              <div className="rightSideContainer">
                {showComponent && this.renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CriterionView;
